import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 .8A7.203 7.203 0 0 0 .8 8c0 3.974 3.226 7.2 7.2 7.2s7.2-3.226 7.2-7.2S11.974.8 8 .8M2.24 8A5.758 5.758 0 0 1 8 2.24a5.69 5.69 0 0 1 3.528 1.217l-8.071 8.071A5.69 5.69 0 0 1 2.24 8M8 13.76a5.69 5.69 0 0 1-3.528-1.217l8.071-8.071A5.69 5.69 0 0 1 13.76 8 5.758 5.758 0 0 1 8 13.76"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInactive;
